import React from 'react';
import PropTypes from 'prop-types';

// import moment, { utc } from 'moment';
// import 'moment/min/locales'
import { utc } from 'moment';
import * as moment from 'moment/min/moment-with-locales';

const FormatedDate = ({ date, i18n }) => {
  if (typeof date === 'undefined') return '';
  const { fullDateFormat, lang } = i18n;
  moment.locale(lang || 'en');
  return (
    <span className="text date">
      {utc(date)
        .local()
        .format(fullDateFormat)}
    </span>
  );
};
FormatedDate.propTypes = {
  date: PropTypes.string.isRequired,
  i18n: PropTypes.shape({
    fullDateFormat: PropTypes.string,
    lang: PropTypes.string,
  }).isRequired,
};

export default FormatedDate;
